const API_URL = process.env.REACT_APP_API_URL;

export const fetchSports = async () => {
  try {
    const response = await fetch(`${API_URL}/sports`);
    if (!response.ok) throw new Error("Failed to fetch sports");
    return await response.json();
  } catch (error) {
    console.error("Error fetching sports:", error);
    throw error;
  }
};

export const fetchClubs = async () => {
  try {
    const response = await fetch(`${API_URL}/clubs`);
    if (!response.ok) throw new Error("Failed to fetch clubs");
    return await response.json();
  } catch (error) {
    console.error("Error fetching clubs:", error);
    throw error;
  }
};

export const fetchMatches = async () => {
  try {
    const response = await fetch(`${API_URL}/matches`);
    if (!response.ok) throw new Error("Failed to fetch matches");
    const matches = await response.json();

    // Fetch related data
    const [sports, clubs] = await Promise.all([fetchSports(), fetchClubs()]);

    // Enrich each match with related data
    const enrichedMatches = matches.map((match) => ({
      ...match,
      Sport: sports.find((sport) => sport.sportId === match.sportId),
      HomeTeam: clubs.find((club) => club.clubId === match.homeTeamId),
      AwayTeam: clubs.find((club) => club.clubId === match.awayTeamId),
    }));

    return enrichedMatches;
  } catch (error) {
    console.error("Error fetching matches:", error);
    throw error;
  }
};

export const addMatch = async (matchData) => {
  try {
    const response = await fetch(`${API_URL}/matches`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(matchData),
    });
    if (!response.ok) throw new Error("Failed to add match");
    const newMatch = await response.json();

    // Fetch related data to enrich the new match
    const [sport, clubs] = await Promise.all([fetchSports(), fetchClubs()]);

    // Return enriched match
    return {
      ...newMatch,
      Sport: sport.find((s) => s.sportId === newMatch.sportId),
      HomeTeam: clubs.find((c) => c.clubId === newMatch.homeTeamId),
      AwayTeam: clubs.find((c) => c.clubId === newMatch.awayTeamId),
    };
  } catch (error) {
    console.error("Error adding match:", error);
    throw error;
  }
};

export const updateMatch = async (match) => {
  try {
    const response = await fetch(`${API_URL}/matches/${match.matchesId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(match),
    });
    if (!response.ok) throw new Error('Failed to update match');
    return await response.json();
  } catch (error) {
    console.error('Error updating match:', error);
    throw error;
  }
};
